import { fontHeading3 } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import React from 'react';
import { fontHeading2 } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { classNames } from '@payfit/growth-platform-brand-system-v2/utils/style';
import { SiteLocale, NbTagRecord } from 'apps/website/types/dato';
import { formatPrice } from '../../../../utils/formatPrice';
import { Tag, TagProps } from '@payfit/growth-platform-brand-system-v2';
type PriceDiscountProps = {
  price?: number;
  locale: SiteLocale;
  discount?: number;
  tag?: NbTagRecord;
};

const PriceDiscount = ({
  price,
  discount,
  locale,
  tag,
}: PriceDiscountProps) => {
  return (
    <div
      className={classNames(
        'PriceBox_PriceDiscount',
        'flex items-center gap-[10px]',
      )}
    >
      <span
        className={classNames(
          'line-through',
          classNames(fontHeading3, 'text-[#96A3B3]'),
        )}
      >
        {!!price && formatPrice(price, locale)}
      </span>
      <span className={classNames(fontHeading2)}>
        {!!discount && formatPrice(discount, locale)}
      </span>
      {tag && <Tag color={tag.color as TagProps['color']}>{tag.title}</Tag>}
    </div>
  );
};

export default PriceDiscount;
